<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-description-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Reason.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Reason.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <form class="zn-form row" [formGroup]="form">
        <div class="form-control-container col">
          <label class="form-label" for="standFusionTransformationReason">
            {{ (localizationKeyPrefix + '.Fields.TransformationReason') | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <textarea
            id="standFusionTransformationReason"
            class="form-control"
            formControlName="transformationReason"
            [placeholder]="`${localizationKeyPrefix}.Fields.TransformationReasonPlaceholder` | abpLocalization"
          ></textarea>
          @if (fieldInvalid('transformationReason')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationKeyPrefix}.RequiredFields` | abpLocalization }}
            </small>
          }
        </div>
      </form>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section stand-division-description-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Summary.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Summary.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-summary">
        <div class="row">
          <div class="col">
            <section>
              <h6>{{ (localizationKeyPrefix + '.Summary.InitialStands') | abpLocalization }}</h6>
              <div class="zn-table" [class.zn-table--empty]="initialRows().length === 0">
                <div class="zn-table-scroll">
                  <table class="zn-table-element">
                    <thead>
                      <tr>
                        <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                        <th>{{ 'Geographic::Entity.Cycle' | abpLocalization }}</th>
                        <th>{{ 'Geographic::Entity.Rotation' | abpLocalization }}</th>
                        <th>{{ 'Planning::Entity.Stand.StandArea' | abpLocalization }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (initialRows().length === 0) {
                        <tr>
                          <td class="zn-table-empty" colspan="4">-----</td>
                        </tr>
                      }

                      @for (row of initialRows(); track row.id) {
                        <tr>
                          <td>{{ row.stand }}</td>
                          <td>{{ formatCycleLabel(row.cycle, row.isLastCycle) }}</td>
                          <td>{{ formatRotationLabel(row.rotation, row.isLastRotation) }}</td>
                          <td>{{ formatArea(row.area) }}</td>
                        </tr>
                      }

                      @if (initialRows().length > 0) {
                        <tr class="zn-resume">
                          <td colspan="3">{{ (localizationKeyPrefix + '.Summary.TotalArea') | abpLocalization }}</td>
                          <td>
                            <span class="zn-total-input">{{ formatArea(initialTotalArea()) }}</span>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
          <div class="col">
            <section>
              <h6>{{ (localizationKeyPrefix + '.Summary.FinalStands') | abpLocalization }}</h6>
              <div class="zn-table" [class.zn-table--empty]="finalRows().length === 0">
                <div class="zn-table-scroll">
                  <table class="zn-table-element">
                    <thead>
                      <tr>
                        <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                        <th>{{ 'Geographic::Entity.Cycle' | abpLocalization }}</th>
                        <th>{{ 'Geographic::Entity.Rotation' | abpLocalization }}</th>
                        <th>{{ 'Planning::Entity.Stand.StandArea' | abpLocalization }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (finalRows().length === 0) {
                        <tr>
                          <td class="zn-table-empty" colspan="4">-----</td>
                        </tr>
                      }

                      @for (row of finalRows(); track row.id) {
                        <tr>
                          <td>{{ row.stand }}</td>
                          <td>{{ formatCycleLabel(row.cycle, row.isLastCycle) }}</td>
                          <td>{{ formatRotationLabel(row.rotation, row.isLastRotation) }}</td>
                          <td>{{ formatArea(row.area) }}</td>
                        </tr>
                      }

                      @if (finalRows().length > 0) {
                        <tr class="zn-resume">
                          <td colspan="3">{{ (localizationKeyPrefix + '.Summary.TotalArea') | abpLocalization }}</td>
                          <td>
                            <span class="zn-total-input">{{ formatArea(finalTotalArea()) }}</span>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
